import { User } from "@/types/Users";
import UserActionBlock from "./UserActionBlock";
import { FC, useState } from "react";
import ChangePasswordModal from "@/components/Modals/ChangePasswordModal";

interface ChangeUserPasswordBlockProps {
  userData: User;
  onSubmit: () => void;
}

const ChangeUserPasswordBlock: FC<ChangeUserPasswordBlockProps> = ({
  userData,
  onSubmit,
}) => {
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

  return (
    <>
      <UserActionBlock
        title="Change Password"
        tooltip="The user will not be able to log in using their previous password."
        buttonProps={{
          primaryText: "Change Password",
          action: () => setShowChangePasswordModal(true),
        }}
      />
      <ChangePasswordModal
        show={showChangePasswordModal}
        onCancel={() => setShowChangePasswordModal(false)}
        onClose={() => setShowChangePasswordModal(false)}
        onSubmit={onSubmit}
        defaultInfo={userData}
      />
    </>
  );
};

export default ChangeUserPasswordBlock;
